import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCloud$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCloud extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '2be05f7eeea414e4e64489c2e143754404d94b4b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'cd26c38f4165c809ee9ea1ab0388d53a6080b7d4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'e62287173fbc64b0947483b38ef1f7883a94ff81', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 5.002h7.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H17a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h1.5v-9h-7.19a.5.5 0 0 1-.44-.28L10 4.502H3.5v6.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-7.5a.5.5 0 0 1 .5-.5h8.14a.5.5 0 0 1 .49.28zm2.5 10.887a2 2 0 0 1-1.944 2h-8.5v-.008a2.25 2.25 0 1 1 .777-4.416 3.5 3.5 0 1 1 6.962.552q.332-.126.705-.128a2 2 0 0 1 2 2", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-cloud", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-cloud"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-cloud":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCloud$1);
            }
            break;
    } });
}

const CosmosIconCloud = CosmosIconCloud$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCloud, defineCustomElement };
